import { render, staticRenderFns } from "./DocumentDownloadsPage.vue?vue&type=template&id=9b56a094&scoped=true"
import script from "./DocumentDownloadsPage.vue?vue&type=script&lang=js"
export * from "./DocumentDownloadsPage.vue?vue&type=script&lang=js"
import style0 from "./DocumentDownloadsPage.vue?vue&type=style&index=0&id=9b56a094&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b56a094",
  null
  
)

export default component.exports